module.exports = "/_next/static/images/contact_2-97a8f2357d87a825470e2df776311dc5.png";